import React from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { HelmetProvider } from "react-helmet-async";
import App from "./tabs/App";
import "./index.css";
import { UserProvider } from "./context/UserContext";
import { SessionProvider } from "./context/SessionContext";
import { ModelProvider } from "./context/ModelContext";
import { HatProvider } from "./context/HatContext";
import { KnowledgeBaseProvider } from "./context/KnowledgeBaseContext";
import { BrainBankSyncProvider } from "./context/BrainBankSyncContext";
import { WorkflowProvider } from "./context/WorkflowContext";
import { InternetProvider } from "./context/InternetContext";
import { MeetingProvider } from "./context/MeetingContext";
import { ThemeProvider } from "./context/ThemeContext";

export const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URI,
  response_type: "code",
  scope: "phone openid email",
  onSigninCallback: (_user: any) => {
    window.history.replaceState({}, document.title, "/");
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('oidc.') && !key.includes('user')) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
  }
};

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider {...cognitoAuthConfig}>
        <ThemeProvider>
          <UserProvider>
            <SessionProvider>
              <ModelProvider>
                <HatProvider>
                  <KnowledgeBaseProvider>
                    <BrainBankSyncProvider>
                      <WorkflowProvider>
                        <InternetProvider>
                          <MeetingProvider>
                            <App />
                          </MeetingProvider>
                        </InternetProvider>
                      </WorkflowProvider>
                    </BrainBankSyncProvider>
                  </KnowledgeBaseProvider>
                </HatProvider>
              </ModelProvider>
            </SessionProvider>
          </UserProvider>
        </ThemeProvider>
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);

